import { z } from '@repo/schema'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import {
  CreateCustomerRiskProfileBodySchema,
  GetCustomerRiskProfileSchema,
} from '@repo/schema/risk-profile'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'

export const createRiskProfilesRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    customers: {
      create: p
        .path('risk-profiles', 'customers')
        .input(CreateCustomerRiskProfileBodySchema)
        .mutation(({ input, path, upFetch }) =>
          upFetch(path, {
            body: input,
            method: 'POST',
            schema: getDataWrapperSchema(GetCustomerRiskProfileSchema),
          }),
        ),
      get: p
        .path(z.object({ customerRiskProfileId: z.number() }), p => [
          'risk-profiles',
          'customers',
          p.customerRiskProfileId,
        ])
        .query(({ path, upFetch }) => upFetch(path, {})),
      scores: p.path('risk-profiles', 'customers', 'scores').query(({ path, upFetch }) =>
        upFetch(path, {
          schema: getDataWrapperSchema(z.object({ title: z.string(), value: z.string() }).array()),
        }),
      ),
    },
  }
}
